var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#1A86E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#1A86E0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2637 9.58203C15.5684 8.97266 16.4316 8.99805 16.7109 9.58203L18.3867 12.959L22.0938 13.4922C22.7539 13.5938 23.0078 14.4062 22.5254 14.8887L19.8594 17.5039L20.4941 21.1855C20.5957 21.8457 19.8848 22.3535 19.3008 22.0488L16 20.2969L12.6738 22.0488C12.0898 22.3535 11.3789 21.8457 11.4805 21.1855L12.1152 17.5039L9.44922 14.8887C8.9668 14.4062 9.2207 13.5938 9.88086 13.4922L13.6133 12.959L15.2637 9.58203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnDriver);
export default __webpack_public_path__ + "static/media/own-driver.de5c3c0e.svg";
export { ForwardRef as ReactComponent };